import { useContext } from 'react'
import { BulkActionContext } from 'shared/contexts/BulkActionContext'

export const useBulkActionContext = () => {
    const bulkActionContext = useContext(BulkActionContext)

    if (!bulkActionContext) {
        throw new Error(
            'useBulkActionContext must be used within <BulkActionContextProvider>'
        )
    }

    return bulkActionContext
}
